import { useTranslations } from "next-intl";
import ProgressBar from "react-bootstrap/ProgressBar";
import classNames from "classnames";

const sections = ["account", "subscription", "profile"];

function SectionProgressBar({
  sectionNumber,
  sectionLastStepNumber,
  currentSectionNumber,
  currentStepNumber,
}) {
  const t = useTranslations("common");

  const stepName = sections[sectionNumber];
  const isBeforeCurrentSection = sectionNumber < currentSectionNumber;
  const isCurrentSection = sectionNumber === currentSectionNumber;
  const isAfterCurrentSection = sectionNumber > currentSectionNumber;

  const stepNumber = () => {
    if (isBeforeCurrentSection) return sectionLastStepNumber;
    if (isAfterCurrentSection) return 0;

    return currentStepNumber;
  }

  return (
    <div className={classNames("progress-content my-auto", !isCurrentSection && "not-current" )}>
      <div className="mb-2 d-flex justify-content-between text-nowrap font-size-xs text-uppercase">
        <span>{t(`tunnel_steps.sections.titles.${stepName}`)}</span>
        <span className="text-primary">{`${stepNumber()}/${sectionLastStepNumber}`}</span>
      </div>

      <ProgressBar
        now={(stepNumber() / sectionLastStepNumber) * 100}
        style={{ height: 4 }}
        data-testid="progress-bar"
      />
    </div>
  );
}

export default SectionProgressBar;
